import { createSlice } from "@reduxjs/toolkit"
const initialState={
    
    currentCollectors:[],
    
}

const collectorSlice=createSlice({
name:'collectors',

initialState,
reducers:{
    
    loginSuccessCollectors:(state,{payload})=>{
        state.currentCollectors=payload;
        

    },
    deleteAllCollectors:(state)=>{
        state.currentCollectors=[];
        

    },
   
    
    

}
})
export const {loginSuccessCollectors,deleteAllCollectors}=collectorSlice.actions

export default collectorSlice.reducer